/** Version recorded on explicit acceptance during account setup. */
export const TERMS_VERSION = '2026-10-04-draft-1';
export const TRIAL_DAYS = 7;
export const TRIAL_HOURS = TRIAL_DAYS * 24;
export const TRIAL_VIDEOS = 3;
export const TRIAL_SECONDS = 15 * 60;
export type BillingInterval = 'month' | 'year';
export type EntitlementMode = 'metered' | 'unlimited';
